<template>
<footer class="mainFooter">
  <div class="flex flex-col w1200 center">
    <div class="flex justify-center center item-center">
      <span> 版权所有 Copyright © 2016-2021 All Rights Reserved. &nbsp;&nbsp;</span>
      <img class="inline-bloch" style="vertical-align: middle; width: 300px;" src="../../assets/images/common/logo_group.png">
    </div>
    <p class="beian" style="display: flex;justify-content: center;align-items: center;">
      <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-right: 12px;"> 备案号： 浙ICP备16033261号-1</a> |
      <img style="width: 20px;height: 20px;margin-left: 12px;" src="../../assets/images/beian.gongan.png">
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010302003094" target="_blank"> 浙公网安备 33010302003094号</a>
    </p>
  </div>
</footer>
</template>